import GenericFilter, { Item } from "@/components/Filters/GenericFilter";
import { IconWind } from "@tabler/icons-react";
import { Select, SelectItem } from "@heroui/react";
import { Image } from "@heroui/react";
import { CDN } from "@/lib/cdn";

interface Attribute {
  key: string;
  value: string;
}

export default function AttributeFilter({
  selected,
  setSelected,
}: {
  selected: Set<string>;
  setSelected: (selectedOptions: Set<string>) => void;
}) {
  const handleSelectionChange = (selectedKeys: Selection) => {
    // Convert Selection to an array of strings
    const selectedItems = Array.from(selectedKeys as any).map(
      (key) => key as string,
    );
    const newSelection = new Set(selectedItems);
    setSelected(newSelection);
  };

  let attributeData: Attribute[] = [
    { key: "ranged", value: "Ranged" },
    { key: "slash", value: "Slash" },
    { key: "special", value: "Special" },
    { key: "strike", value: "Strike" },
    { key: "wisdom", value: "Wisdom" },
    { key: "slash_strike", value: "Slash/Strike" },
    { key: "slash_special", value: "Slash/Special" },
    { key: "strike_ranged", value: "Strike/Ranged" },
    { key: "strike_special", value: "Strike/Special" },
  ];

  return (
    <div className="w-[160px]">
      <Select
        size="sm"
        aria-label={"Attribute"}
        placeholder="Attribute"
        selectedKeys={Array.from(selected)}
        selectionMode="single"
        startContent={<IconWind />}
        className="max-w-xs"
        onSelectionChange={handleSelectionChange as any}
      >
        {attributeData.map((attribute) => (
          <SelectItem
            key={attribute.key}
            aria-label={attribute.key}
            startContent={
              <Image
                alt={attribute.key}
                src={`${CDN}/games/one-piece/images/attributes/${attribute.key}.webp`}
                height={18}
                width={18}
                className="rounded-none"
              />
            }
          >
            {attribute.value}
          </SelectItem>
        ))}
      </Select>
      {/* <Button color="primary" onClick={handleReset}>
              Reset
          </Button> */}
      {/* <p className="text-small text-default-500">Selected: {Array.from(selected).join(', ')}</p> */}
    </div>
  );
}
